import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=87796452&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=87796452&prod&lang=scss&scoped=true&"
import style1 from "./nav.vue?vue&type=style&index=1&id=87796452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87796452",
  null
  
)

export default component.exports